// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q0e3","newExpiryDate":"styles_newExpiryDate__28EF9","footer":"styles_footer__5zdeu"};